<template>
  <div class="wa--default-layout">
    <slot />
  </div>
</template>
<style lang="scss">
.wa--default-layout {
  width: 100%;
}
</style>
<script>

export default {
  name: "DefaultLayout"
};
</script>
